<template>
  <SortDropdown
    :items="sortValues"
    :animation="animation"
    data-test="sort-dropdown-button"
    class="x-z-[3]"
  >
    <template #toggle="{ isOpen }">
      <div
        class="x-button x-button-ghost x-text1 x-text1-lg x-flex x-items-center x-rounded-full x-text-left x-font-light"
        :class="isMobile ? 'x-min-h-32 x-w-full x-max-w-[240px] x-gap-4' : 'x-h-40 x-gap-[6px]'"
      >
        <span class="x-flex-shrink-0">{{ $t('sort.label') }}</span>
        <span class="x-line-clamp-1 x-text-lead-75">{{
          $t(`sort.values.${x.selectedSort || 'default'}`)
        }}</span>
        <ChevronUpIcon v-if="isOpen" class="x-icon x-icon-stroke-width-xl x-ml-auto" />
        <ChevronDownIcon v-else class="x-icon-md x-icon-stroke-width-xl x-ml-auto" />
      </div>
    </template>

    <template #item="{ isSelected, item }">
      <div
        class="x-facet-filter x-z-30 x-w-[222px] x-bg-neutral-0 x-px-16 x-text-neutral-100 hover:x-bg-neutral-25 hover:x-text-neutral-90"
        :class="{ 'x-bg-neutral-25': isSelected }"
      >
        <span class="x-text2 x-text2-sm">{{ $t(`sort.values.${item || 'default'}`) }}</span>
      </div>
    </template>
  </SortDropdown>
</template>

<script lang="ts">
import type { Sort } from '@empathyco/x-types'
import { animateScale, ChevronDownIcon, ChevronUpIcon, use$x } from '@empathyco/x-components'
import { SortDropdown } from '@empathyco/x-components/search'
import { defineComponent } from 'vue'
import { useDevice } from '../../composables/use-device.composable'

export default defineComponent({
  name: 'Sort',
  components: {
    SortDropdown,
    ChevronUpIcon,
    ChevronDownIcon,
  },
  setup() {
    const { isMobile } = useDevice()
    const sortValues: Sort[] = ['', 'currentPrice asc', 'currentPrice desc']
    const x = use$x()
    const animation = animateScale() as any

    return {
      sortValues,
      isMobile,
      x,
      animation,
    }
  },
})
</script>
<style lang="scss">
.x-dropdown__items-list {
  width: 200px;
  text-align-last: start;
}
.x-dropdown__item {
  width: 100%;
}
</style>
